import { Box, ButtonBase, TableCell } from "@mui/material";
import type { JSX } from "react";

import { headCellSx } from "./tableStyles.js";
import type { SortDir, SortKey } from "./sortLeads.js";

/* ── Sortable header ───────────────────────────────────────────── */

export function Th({
  sort, colKey, onClick, width, children,
}: {
  sort: { key: SortKey; dir: SortDir };
  colKey: SortKey;
  onClick: (k: SortKey) => void;
  width?: number;
  children: React.ReactNode;
}): JSX.Element {
  const active = sort.key === colKey;
  const arrow = active ? (sort.dir === "asc" ? " ▲" : " ▼") : "";
  return (
    <TableCell sx={[headCellSx, ...(width ? [{ width }] : [])]}>
      <ButtonBase
        onClick={() => onClick(colKey)}
        sx={[
          { display: "inline-flex", alignItems: "center", gap: 0.25, font: "inherit", letterSpacing: "inherit", textTransform: "inherit" },
          active && { color: "text.primary" },
        ]}
      >
        {children}
        <Box component="span" aria-hidden>{arrow}</Box>
      </ButtonBase>
    </TableCell>
  );
}
